var $ = require('jquery');
var _ = require('lodash');
var stats = require('stats/stats');
var language = readActLang("django_language")

var $somewall = $('#somewall'),
    count,
    baseUrl = '/' + language + '/somewall/';

var $filters, $someItems = [];

var unbind = function (){
    $(window).unbind('scroll', checkForSomewall);
};
var checkForSomewall = function () {
// Trigger social stream 50px before its placeholder comes to view
  var scroll = parseInt($(window).scrollTop(), 10);
  if ($somewall.offset().top - $(window).height() - 50 < scroll) {
      unbind();
      count = $somewall.data('count') || null;
      loadSomewall('all', true);
  }
};

var filterItems = function (e) {
    var currentSome = $(this).data('smedia'),
        $currentItems = [];
    $filters.removeClass('selected');
    $(this).addClass('selected');
    loadSomewall(currentSome, false);
};

var renderSomewall = function (data, updateFilters) {
    if(updateFilters) {
        $somewall.html(data);
        $filters = $somewall.find('.filters .button');
        $filters.click(filterItems);
    } else {
      $somewall.find('.walls').replaceWith($(data));
    }
};

var loadSomewall = function (source, updateFilters) {
    $somewall.addClass('loading');
    var url = baseUrl + $somewall.data('slug') + '?';
    if (!updateFilters) {
        url += 'full=false&';
    }

    if (count) {
      url += 'count=' + count + '&';
    }

    if (source !== undefined || source !== 'all') {
        url += 'source=' + source;
    }
    $.get(url, function (data) {
      renderSomewall(data, updateFilters);
      $somewall.removeClass('loading');
    });
};

if ($somewall.length) {
    module.exports = checkForSomewall;
} else {
    module.exports = unbind;
}



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/somewall.js
// module id = 12
// module chunks = 0